import { render, staticRenderFns } from "./EventMovieConfigurationView.vue?vue&type=template&id=63b0fca9&"
import script from "./EventMovieConfigurationView.vue?vue&type=script&lang=js&"
export * from "./EventMovieConfigurationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports